import { BrowserId } from 'Browser/BrowserId';
import { ConnectionToServer } from 'Shared/Root';
import {createContext,JSX,mergeProps,useContext} from 'solid-js';
import { createStore, SetStoreFunction } from 'solid-js/store';

interface ISharedStore<D> {
	store: D;
	setStore: SetStoreFunction<D>;
	location: Location;

	/*
		I THINK 'afterUpdate' is useful for creating a subdoc when the 'parent'/'controlling' select box sits OUTSIDE the subdoc,
		while 'prepareParent' is useful when the select box sits INSIDE the subdoc. 
	*/
	afterUpdate?: (value:any,retValue:any) => Promise<void>;
//TODO? complement with a prepareChild()/updateChild() option that includes a call to dbReplaceField() and a store update

	/*
		Only called if the parent doesn't already exist, and returns the initial value.
		If necessary can include other preparatory steps (eg creating other fields, asynchronously
		if need be).
	*/
	prepareParent?: (field:string, value:any) => Promise<any>;
}

export interface IDbStore<D> extends ISharedStore<D> {
	noDb?: false,
	server: ConnectionToServer;
	page: string;
	permission: string;
	docId: BrowserId;
	imageFolder?: string;
}

export interface INoDbStore<D> extends ISharedStore<D> {
	noDb: true
}

//export type IStoreWrap<D> = IDbStore<D> | INoDbStore<D>;
export type IStoreWrap<D> = IDbStore<D>;


const StoreContext = createContext();

export function StoreProvider<D>(P:IStoreWrap<D> & {children:JSX.Element})
{
	return (
		<StoreContext.Provider value={P}>
			{P.children}
		</StoreContext.Provider>
	);
}

export interface ICreateStore<D> {
	initial: D;
	server: ConnectionToServer
	page: string;
	permission: string;
	docId: BrowserId;
	location: Location;
	imageFolder?: string;
}

export function CreateStoreProvider<D>(P:ICreateStore<D> & {children:JSX.Element})
{
	const [store,setStore] = createStore(P.initial);

	const value = mergeProps(P,{
		store:store,
		setStore:setStore
	});

	return (
		<StoreContext.Provider value={value}>
			{P.children}
		</StoreContext.Provider>
	);
}

export function useStore<D>():IStoreWrap<D> 
{
	return useContext(StoreContext);
}

/*
	{...sw} only seems to work in JSX. Something to do with the way Providers work I guess.
	Sometimes its necessary to modify location before calling
	a BaseOperation or similar. This function can be used for this purpose.
*/
export function cloneSw(sw)
{
	return {
		store: sw.store,
		setStore: sw.setStore,
		initial: sw.initial,
		server: sw.server,
		page: sw.page,
		permission: sw.permission,
		docId: sw.docId,
		location: sw.location,
		imageFolder: sw.imageFolder
	};
}

